import { ref } from 'vue'
import _ from 'lodash'

export const useVoucherTable = () => {
  const selectedProduct = ref(null)
  const voucherTableRow = ref([])

  /**
   * 이용권 테이블 행 리스트를 반환
   * @param voucherList
   * @param descriptionList
   * @returns Array
   */
  const voucherTableList = (voucherList, descriptionList) => {
    if (!descriptionList) {
      return []
    }

    return descriptionList.map(({ title = '', type = '', key }) => {
      const voucherItem = voucherList.map((voucher) => {
        const concurrency = voucher?.concurrency?.[0] ?? {}
        const orderKey = concurrency?.products_order ?? ''
        return { [orderKey]: concurrency?.[key] || '' }
      })

      return {
        title,
        type,
        voucherItem,
      }
    })
  }

  /**
   * 구매 프로세스의 페이로드를 정제하여 반환
   * (컴포넌트에서 voucherPurchaseFn 이벤트로 전달 됨)
   * @param voucher
   * @param product
   * @returns {*&{amount, productid, displayamount}}
   */
  const refinePurchasePayload = (voucher, product) => {
    const productId = product?.productid ?? ''
    const { amount, productid, displayamount } = product
    _.set(voucher, 'concurrency.0.productid', productId)
    selectedProduct.value = productId

    return { ...voucher, amount, productid, displayamount }
  }

  /**
   * get voucher table row (ui)
   * @param voucherList
   * @param bodyDescriptionList
   */
  const getVoucherTableRow = (voucherList, bodyDescriptionList) => {
    voucherTableRow.value = voucherTableList(voucherList, bodyDescriptionList)
  }

  return {
    selectedProduct,
    voucherTableRow,
    voucherTableList,
    refinePurchasePayload,
    getVoucherTableRow,
  }
}
